export default class Utils {
    static createLabel(string) {
        const formattedString = string.charAt(0).toUpperCase() + string.slice(1);
        const finalString = formattedString.replace(/_/g, " ");
        return finalString;
    }
}